import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js/stable";
import "regenerator-runtime/runtime";

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "./i18n";

window.addEventListener("error", (e) => {
  try {
    const msg = `${e.message || "Error"} ${
      e.filename ? "at " + e.filename : ""
    }:${e.lineno || ""}:${e.colno || ""}`;
    const el = document.createElement("pre");
    Object.assign(el.style, {
      position: "fixed",
      zIndex: 999999,
      right: 0,
      top: 0,
      maxWidth: "40%",
      maxHeight: "60vh",
      overflow: "auto",
      background: "rgba(0,0,0,0.85)",
      color: "white",
      padding: "12px",
      fontSize: "12px",
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
    });
    el.textContent =
      msg + (e.error && e.error.stack ? "\n\n" + e.error.stack : "");
    document.body.appendChild(el);
    console.error(e.error || e);
    if (navigator.sendBeacon) {
      try {
        navigator.sendBeacon(
          "/__client_error_log",
          JSON.stringify({ msg, stack: e.error?.stack })
        );
      } catch (be) {}
    }
  } catch (err) {
    console.error("Error overlay failed", err);
  }
});

window.addEventListener("unhandledrejection", (e) => {
  try {
    const reason =
      e.reason && e.reason.message
        ? e.reason.message
        : JSON.stringify(e.reason);
    alert("Unhandled promise rejection: " + reason);
    console.error("Unhandled rejection", e.reason);
  } catch (err) {
    console.error("unhandledrejection handler failed", err);
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
